import { Link } from "react-router-dom";
import kinRamenImage from "../../../assets/images/resource/kinRamenMenu.webp";
import kinKaraRamenImage from "../../../assets/images/resource/karaKinRamenMenu.webp";
import kaisenRamenMenuImage from "../../../assets/images/resource/kaisenRamenMenu.webp";
import karaKaisenRamenMenuImage from "../../../assets/images/resource/karaKaisenRamenMenu.webp";
import shioTraffleRamenMenuImage from "../../../assets/images/resource/shioTraffleRamenMenu.webp";

import curryRamenMenuImage from "../../../assets/images/resource/curryRamenMenu.webp";
import soyVeganRamenMenuImage from "../../../assets/images/resource/soyVeganRamenMenu.webp";
import karaSoyVeganRamenMenuImage from "../../../assets/images/resource/karaSoyVeganRamenMenu.webp";
import misoRamenMenuImage from "../../../assets/images/resource/misoRamenMenu.webp";
import karaMisoRamenMenuImage from "../../../assets/images/resource/karaMisoRamenMenu.webp";

import chickenRamenMenuImage from "../../../assets/images/resource/chickenRamenMenu.webp";
import karaChickenRamenMenuImage from "../../../assets/images/resource/karaChickenRamenMenu.webp";
import shoyuRamenMenuImage from "../../../assets/images/resource/shoyuRamenMenu.webp";

import spicyImage from "../../../assets/images/resource/spicy.png";
import vegetableImage from "../../../assets/images/resource/vegetable.png";
function Ramenmenu() {
  return (
    <>
      <section className="menu-one">
        <div className="auto-container">
          <div className="title-box centered">
            <h2>Ramen Menu</h2>
          </div>
          <div className="row clearfix">
            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={kinRamenImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Kin</Link>
                </h4>
                <div className="text desc">
                  Homemade pork broth, homemade pork chashu , scallion, menma,
                  kikurage, red ginger, shallot chip & nori
                </div>
                <div className="price">$20.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={kinKaraRamenImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Kara Kin</Link>
                  &nbsp;
                  <img src={spicyImage} alt="Icon" width={30} height={30}></img>
                </h4>
                <div className="text desc">
                  Homemade pork broth, homemade pork chashu, scallion, menma,
                  kikurage, red ginger, shallot chip & nori, homemade spicy
                  paste & oil
                </div>
                <div className="price">$22.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={kaisenRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Kaisen</Link>
                </h4>
                <div className="text desc">
                  Homemade pork broth, giant river shrimp, scallop, mussel,
                  squid, bean sprout, scallion, kikurage, cabbage, onion &
                  ground garlic
                </div>
                <div className="price">$27.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={karaKaisenRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Kara Kaisen</Link>
                  &nbsp;
                  <img src={spicyImage} alt="Icon" width={30} height={30}></img>
                  <img src={spicyImage} alt="Icon" width={30} height={30}></img>
                </h4>
                <div className="text desc">
                  Homemade pork broth, homemade spicy paste & oil giant river
                  shrimp, scallop, mussel, squid, bean sprout, scallion,
                  kikurage, cabbage, onion & ground garlic
                </div>
                <div className="price">$29.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="400ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={shioTraffleRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Shio Truffle</Link>
                </h4>
                <div className="text desc">
                  Homemade chicken broth, chicken chashu, half ajitama, bean
                  sprout, menma, truffle paste, nori, shiso & truffle paste
                </div>
                <div className="price">$22.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="600ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={curryRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Curry Ramen</Link>
                  &nbsp;
                  <img src={spicyImage} alt="Icon" width={30} height={30}></img>
                </h4>
                <div className="text desc">
                  Homemade curry broth, crispy pork, half ajitama, scallion, red
                  ginger & heavy cream
                </div>
                <div className="price">$24.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={soyVeganRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Soy Vegan</Link>
                  &nbsp;
                  <img
                    src={vegetableImage}
                    alt="Icon"
                    width={30}
                    height={30}
                  ></img>
                </h4>
                <div className="text desc">
                  Premium soy broth with organic vegetable puree, zucchini,
                  pumpkin, watermelon radish, champignon, leek, scallion, seared
                  tofu
                </div>
                <div className="price">$24.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="0ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={karaSoyVeganRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Kara Soy Vegan</Link>
                  &nbsp;
                  <img
                    src={vegetableImage}
                    alt="Icon"
                    width={30}
                    height={30}
                  ></img>
                  <img src={spicyImage} alt="Icon" width={30} height={30}></img>
                </h4>
                <div className="text desc">
                  Homemade spicy paste & oil ,premium soy broth with organic
                  vegetable puree, zucchini, pumpkin, watermelon radish,
                  champignon, leek, scallion, seared tofu
                </div>
                <div className="price">$26.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={misoRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Miso</Link>
                </h4>
                <div className="text desc">
                  Homemade chicken broth, homemade pork chashu, spicy ground
                  pork, bean sprout, scallion, corn, chive & cilantro
                </div>
                <div className="price">$20.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={karaMisoRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Kara Miso</Link>
                  &nbsp;
                  <img src={spicyImage} alt="Icon" width={30} height={30}></img>
                  <img src={spicyImage} alt="Icon" width={30} height={30}></img>
                </h4>
                <div className="text desc">
                  Homemade chicken broth, homemade pork chashu, homemade spicy
                  paste & oil, spicy ground pork, bean sprout, scallion, corn,
                  chive & cilantro
                </div>
                <div className="price">$22.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="400ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={chickenRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Chicken</Link>
                </h4>
                <div className="text desc">
                  Homemade chicken broth, chicken chashu, half ajitama, bean
                  sprout, bok choy, corn, cilantro, red onion & shallot chip
                </div>
                <div className="price">$20.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="400ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={karaChickenRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Kara Chicken</Link>
                  &nbsp;
                  <img src={spicyImage} alt="Icon" width={30} height={30}></img>
                </h4>
                <div className="text desc">
                  Homemade chicken broth, homemade spicy paste & oil, chicken
                  chashu, half ajitama, bean sprout, bok choy, corn, cilantro,
                  red onion & shallot chip
                </div>
                <div className="price">$22.00</div>
              </div>
            </div>

            <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
              <div
                className="inner-box wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="600ms"
              >
                <div className="image">
                  <Link to="#">
                    <img src={shoyuRamenMenuImage} alt="" />
                  </Link>
                </div>
                <h4>
                  <Link to="/menu">Shoyu</Link>
                </h4>
                <div className="text desc">
                  Homemade chicken broth, homemade pork chashu, bean sprout,
                  scallion, half ajitama, menma, leek & nori
                </div>
                <div className="price">$20.00</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Ramenmenu;
